const CTA_TYPE_BRAZE = 'web_braze';
const CTA = () => ({
  gtm: {
    action: 'Hero',
    category: null,
    label: null,
  },
  type: CTA_TYPE_BRAZE,
  url: 'https://www.theiconic.com.au/mens-clothing/',
});

const ImageSize = () => ({
  height: 0,
  width: 0,
  url: null,
  webUrl: null,
});

const Image = () => ({
  aspect: 1,
  blur: {
    data: null,
    ...(ImageSize()),
  },
  sizes: [],
});

const HeroImage = () => ({
  alt: 'Braze Content Card',
  alternatives: {
    Mobile: Image(),
  },
  ...(Image()),
});

const ContentCard = () => ({
  alignment: 'Centre',
  alignment_mobile: 'Same as desktop',
  content_container_width: 'normal',
  copy: null,
  copy_enabled: 'All devices',
  copy_typography: 'sans-serif',
  countdown_until_time: null,
  cta: CTA(),
  cta_type: 'Whole Header',
  hero_Mobile_video: null,
  hero_image: HeroImage(),
  hero_video: null,
  position: 'Right',
  position_mobile: 'Same as desktop',
  sound_button_position: 'Bottom left',
  subtitle: null,
  theme: 'Light Text',
  theme_mobile: 'Same as desktop',
  typography: 'sans-serif',
  vector_image_location: 'Overlay',
});

export {
  CTA,
  CTA_TYPE_BRAZE,
  ImageSize,
  Image,
  HeroImage,
  ContentCard,
};
